import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { ContractorTransferWizard, EntityHeader, HasSidebarLayout } from 'src/components'

const ContractorTransferNew: FC = () => {
  document.title = 'CLīMIT Admin Panel - New transfer'
  const navigate = useNavigate()

  return (
    <HasSidebarLayout>
      <EntityHeader title="New transfer" onBack={() => navigate('/settings?tab=Transfer')} />
      <ContractorTransferWizard />
    </HasSidebarLayout>
  )
}

export default ContractorTransferNew
